import { render } from "./CardAnalysis.vue?vue&type=template&id=1535e61a"
import script from "./CardAnalysis.vue?vue&type=script&lang=js"
export * from "./CardAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__